const fmtDiff = (d) => (d === 0 ? "0" : `${d > 0 ? "+" : "−"}${Math.abs(d).toFixed(2)}`);

export default function DimMatchBadges({ product }) {
    if (!product.dim_matches?.length) return null;
    return (
        <div className="mt-2 flex flex-wrap gap-1" data-testid={`dim-matches-${product.id}`}>
            {product.dim_matches.map((m) => (
                <span
                    key={m.key}
                    className={`text-[10px] font-mono px-1.5 py-0.5 rounded border ${
                        m.diff === 0 ? "bg-emerald-50 border-emerald-200 text-emerald-700" : "bg-orange-50 border-orange-200 text-orange-700"
                    }`}
                    data-testid={`dim-match-${product.id}-${m.key}`}
                >
                    <b>{m.key}</b> {m.value} ({fmtDiff(m.diff)})
                </span>
            ))}
        </div>
    );
}
